export { DialogFooter } from './DialogFooter'
